import { useId, useRef, useState, type DragEvent } from 'react';
import { FileTextIcon, UploadIcon, XIcon } from 'lucide-react';
import { RECEIPT_FILE_TYPES } from '../../../core/rules/stockCount';
type Props = {
  file: File | null;
  preview: string | null;
  error: string | null;
  onChange: (file: File | null) => void;
};
const sizeLabel = (bytes: number) => bytes < 1024 * 1024 ? `${Math.max(1, Math.round(bytes / 1024))} kB` : `${(bytes / 1024 / 1024).toFixed(1).replace('.', ',')} MB`;

/** De factuur als PDF of foto: slepen, kiezen, of op de telefoon direct een foto maken. */
export function ReceiptFileField({
  file,
  preview,
  error,
  onChange
}: Props) {
  const id = useId();
  const input = useRef<HTMLInputElement>(null);
  const [over, setOver] = useState(false);
  const drop = (e: DragEvent) => {
    e.preventDefault();
    setOver(false);
    const dropped = e.dataTransfer.files[0];
    if (dropped) onChange(dropped);
  };
  if (file) {
    return <div className="flex items-center gap-3 rounded-md bg-shell p-3" data-id="element-4625" data-mp="22sir6wlwymoz">
        {preview ? <img src={preview} alt="" className="h-14 w-14 shrink-0 rounded object-cover" data-id="element-4626" data-mp="3shqz2vfrlccf" /> : <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded bg-sand text-clay" aria-hidden="true" data-id="element-4627" data-mp="19mn37t3z57a">
            <FileTextIcon className="h-6 w-6" strokeWidth={1.5} data-id="element-4628" data-mp="3ji3yucyrucky" />
          </span>}
        <span className="min-w-0 flex-1" data-id="element-4629" data-mp="3ogysk9ya1lju">
          <span className="block truncate text-[14px] text-ink" data-id="element-4630" data-mp="39pg37ljj2ent">{file.name}</span>
          <span className="block text-[12px] text-muted" data-id="element-4631" data-mp="3egelurrznou8">{sizeLabel(file.size)} · gaat mee met de boeking</span>
        </span>
        <button type="button" onClick={() => onChange(null)} aria-label="Bijlage weghalen" className="flex h-10 w-10 items-center justify-center rounded-md text-muted transition-colors duration-150 ease-soft hover:bg-sand hover:text-ink" data-id="element-4632" data-mp="30q2u4tzbfs3m">
          <XIcon className="h-4 w-4" strokeWidth={1.75} aria-hidden="true" data-id="element-4633" data-mp="2qrvmx2utwoet" />
        </button>
      </div>;
  }
  return <div data-id="element-4634" data-mp="119ygs93pe3r4">
      <label htmlFor={id} onDragOver={e => {
      e.preventDefault();
      setOver(true);
    }} onDragLeave={() => setOver(false)} onDrop={drop} className={`flex cursor-pointer flex-col items-center justify-center gap-1.5 rounded-md border border-dashed px-4 py-6 text-center transition-colors duration-150 ease-soft ${over ? 'border-clay bg-blush/30' : 'border-line bg-shell hover:border-ink/30'}`} data-id="element-4635" data-mp="119q68nv1zaj3">
        <UploadIcon className="h-5 w-5 text-clay" strokeWidth={1.75} aria-hidden="true" data-id="element-4636" data-mp="1g7936dhvwu1m" />
        <span className="text-[14px] text-ink" data-id="element-4637" data-mp="1g5egatn1yruw">Sleep de factuur hierheen, of kies een bestand</span>
        <span className="text-[12px] text-muted" data-id="element-4638" data-mp="1b9z4e78lv614">PDF of foto, tot 10 MB. Optioneel, maar handig voor de boekhouder.</span>
      </label>
      <input ref={input} id={id} type="file" accept={RECEIPT_FILE_TYPES.join(',')} className="sr-only" onChange={e => {
      onChange(e.target.files?.[0] ?? null);
      e.target.value = '';
    }} data-id="element-4639" data-mp="3vywp7dvd125n" />
      {error && <p role="alert" className="mt-1.5 text-[12px] text-clay" data-id="element-4640" data-mp="3lu6pzfrccc54">
          {error}
        </p>}
    </div>;
}